import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FeatureState } from '@modeso/aumico-lib-core-fe';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store, select } from '@ngrx/store';
import Debug from 'debug';
import { of } from 'rxjs';
import { catchError, map, mergeMap, withLatestFrom } from 'rxjs/operators';
import * as fromActions from '../actions/configurations.actions';
import { SelectAllLocales } from '../reducers/configurations.reducer';
import { ConfigurationsService } from '../services/configurations.service';

const debug = Debug('aumico:aumico-lib-core-fe:ConfigurationsEffects');

@Injectable()
export class ConfigurationsEffects {
    constructor(
        private readonly actions$: Actions,
        private readonly service: ConfigurationsService,
        private readonly store: Store<FeatureState>,
    ) {}

    getSupportedLocales$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fromActions.configurationsActions.getSupportedLocales.type),
            withLatestFrom(this.store.pipe(select(SelectAllLocales))),
            mergeMap((response) => {
                const supportedLocalesFromStore = response[1];
                if (supportedLocalesFromStore != null && supportedLocalesFromStore.length > 0) {
                    return of(
                        fromActions.configurationsActions.getSupportedLocalesSuccess({
                            payload: supportedLocalesFromStore,
                        }),
                    );
                } else {
                    return this.service.getSupportedLocales$().pipe(
                        map((response) => {
                            return fromActions.configurationsActions.getSupportedLocalesSuccess({
                                payload: response,
                            });
                        }),
                        catchError((error: HttpErrorResponse) => {
                            return of(
                                fromActions.configurationsActions.getSupportedLocalesFailed({
                                    payload: error,
                                }),
                            );
                        }),
                    );
                }
            }),
        ),
    );
}
